import React, { FC } from 'react';
import { GoBackBtn } from '../header/GoBackBtn';
import { useLocation } from 'react-router';

const NewApplicationHeader: FC = () => {

  const { state } = useLocation();

  return (
    <div className="card mb-10 mt-5 bg-transparent">
      <div className="w-100 m-0 py-0 d-flex justify-content-between align-items-center">
        <div className="mb-0 d-flex align-items-center fs-2 fw-bolder">
          <GoBackBtn path={`/accounts/applications${state?.search || ''}`} />
        </div>
      </div>
    </div>
  );
};

export default NewApplicationHeader;
